import { render, staticRenderFns } from "./stock-page.vue?vue&type=template&id=30023058"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30023058')) {
      api.createRecord('30023058', component.options)
    } else {
      api.reload('30023058', component.options)
    }
    module.hot.accept("./stock-page.vue?vue&type=template&id=30023058", function () {
      api.rerender('30023058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/Stock/stock-page.vue"
export default component.exports